"use client"

import { usePathname } from "next/navigation"
import { useEffect, useState } from "react"

export const useMobileCategories = () => {
  const [showMobileCategories, setShowMobileCategories] = useState<boolean>(false)

  useEffect(() => {
    if (showMobileCategories) {
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = "auto"
    }
  }, [showMobileCategories])

  const pathname = usePathname()

  useEffect(() => {
    if (pathname) {
      setShowMobileCategories(false)
    }
  }, [pathname])

  const toggleMobileCategories = () => {
    setShowMobileCategories((prev) => !prev)
  }

  return {
    showMobileCategories,
    toggleMobileCategories,
  }
}
